import { deepMerge } from '@sds-system/utils';
import type { PartialDeep, Theme } from '..';
import { theme } from '..';

export const createTheme = <T>(customTheme: T & PartialDeep<Theme>) => {
  const newTheme = deepMerge(theme, customTheme);

  return newTheme;
};
